import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Fragment } from 'react';
import { withStyles } from '@mui/styles';
import { ButtonContained } from '../Button';

const styles = {
  dialogPaper: {
    minWidth: '350px',
  },
};
export const InfoDialog = ({ classes, stateAddress, toggleHide, msg }) => {
  const handleClose = () => {
    toggleHide(true);
  };

  return stateAddress.show
    ? ReactDOM.createPortal(
      <Fragment>
        <div>
          <Dialog
            open={stateAddress.show}
            onClose={handleClose}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
            sx={{
              minHeight: '200px',
              minWidth: '300px',
            }}
            style={{ minWidth: '350px' }}
            classes={{ paper: classes.dialogPaper }}
          >
            <DialogTitle id='alert-dialog-title' sx={{ fontSize: 'larger' }}>
              Information
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id='alert-dialog-description'
                sx={{ fontSize: '12pt' }}
              >
                {msg}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <ButtonContained onClick={() => handleClose()}>Ok</ButtonContained>
            </DialogActions>
          </Dialog>
        </div>
      </Fragment>,
      document.body,
    )
    : null;
};

InfoDialog.propTypes = {
  stateAddress: PropTypes.object,
  toggleHide: PropTypes.func,
  msg: PropTypes.string,
  classes: PropTypes.any,
};

export default withStyles(styles)(InfoDialog);
